import { useWalletContext } from '@/providers/WalletProvider';

export const useWallet = () => {
  const {
    brandCoins,
    btcMigRequired,
    chainInfo,
    coreGetWalletItems,
    coreEthCoin,
    coreWalletCoins,
    coreWalletCoinState,
    coreWalletError,
    findCoinByUniqueKey,
    findFeeCoinFor,
    getUserWalletData,
    getWalletItems,
    handleGetActiveWallets,
    hasAnyEthWallet,
    hasBothEthWallets,
    hasCoreWallet,
    hasNoWallet,
    hasDuplicateWallets,
    isCoinLoading,
    walletCoins,
    walletCoinState,
    walletError,
    walletInfo,
    ethCoin,
  } = useWalletContext();

  return {
    brandCoins,
    btcMigRequired,
    chainInfo,
    coreGetWalletItems,
    coreEthCoin,
    coreHasError: coreWalletError,
    coreWalletCoins,
    coreWalletCoinState,
    findCoinByUniqueKey,
    findFeeCoinFor,
    getUserWalletData,
    getWalletItems,
    handleGetActiveWallets,
    hasAnyEthWallet,
    hasBothEthWallets,
    hasCoreWallet,
    hasDuplicateWallets,
    hasNoWallet,
    hasError: walletError,
    isCoinLoading,
    ethCoin,
    walletCoins,
    walletCoinState,
    walletInfo,
  };
};
